import api from '../../../services/api';
import type { Customer, CustomerSubmitValues } from '../types';

export async function createCustomer(payload: CustomerSubmitValues): Promise<Customer> {
  const response = await api.post('/customers', payload);
  return response.data;
}
